import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditCreateService } from '../../../app-shared';
import { HttpService, NotificationService } from '../../../tms-shared';
import { UserPrinterDocument } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserPrinterDocumentService extends TmsWebBaseEditCreateService<UserPrinterDocument, UserPrinterDocument> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('UserPrinterDocument', $localize`User Printer Document`, httpService, notificationService);
  }

  getAllDocuments(userPrinterId: string): Observable<UserPrinterDocument[]> {
    return this.httpService.get<UserPrinterDocument[]>(`${this.apiUrl}/GetAllDocuments?id=${userPrinterId}`);
  }

  updateUserPrinterDocuments(userPrinterId: string, documentIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateUserPrinterDocuments`, {
      userPrinterId,
      documentIds,
    });
  }
}
